module.exports = {"pathContext":{"name":"WastageReason","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"EXPIRED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"OTHER"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"VALIDATED_COUNT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"WASTAGE"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-wastage-reason.json
// module id = 1333
// module chunks = 44949783951019